import { Link } from "react-router-dom";
import { featuredProducts } from "@/mocks/products";
import { useCart } from "@/contexts/CartContext";
import { useState } from "react";

export default function FeaturedProducts() {
  const { addToCart } = useCart();
  const [addedId, setAddedId] = useState<string | null>(null);

  const handleAdd = (product: typeof featuredProducts[0]) => {
    addToCart(product);
    setAddedId(product.id);
    setTimeout(() => setAddedId(null), 1500);
  };

  return (
    <section className="py-24 bg-[#F9F7F3]">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-14 gap-4">
          <div>
            <span className="text-[#4A7C2F] text-sm font-medium tracking-widest uppercase">Handpicked For You</span>
            <h2 className="text-4xl font-bold text-[#1a1a1a] mt-2" style={{ fontFamily: "'Playfair Display', serif" }}>
              Featured Collection
            </h2>
          </div>
          <Link
            to="/products"
            className="text-[#2D5016] text-sm font-semibold flex items-center gap-2 hover:gap-3 transition-all whitespace-nowrap cursor-pointer"
          >
            View All 30 Products <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        {/* Product Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {featuredProducts.map(product => (
            <div key={product.id} className="group bg-white rounded-2xl overflow-hidden hover:shadow-lg transition-all duration-300">
              {/* Image */}
              <Link to={`/product/${product.id}`} className="block relative overflow-hidden">
                <div className="w-full h-72">
                  <img
                    src={product.images[0]}
                    alt={product.name}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                {product.badge && (
                  <span className="absolute top-4 left-4 bg-[#2D5016] text-white text-xs font-semibold px-3 py-1 rounded-full">
                    {product.badge}
                  </span>
                )}
              </Link>

              {/* Info */}
              <div className="p-6">
                <div className="flex items-start justify-between gap-2 mb-2">
                  <Link to={`/product/${product.id}`}>
                    <h3 className="text-[#1a1a1a] font-semibold text-base leading-snug hover:text-[#2D5016] transition-colors cursor-pointer">
                      {product.name}
                    </h3>
                  </Link>
                </div>
                <div className="flex items-center gap-1.5 mb-4">
                  <div className="flex items-center gap-0.5">
                    {[1, 2, 3, 4, 5].map(star => (
                      <i
                        key={star}
                        className={`text-xs ${star <= Math.round(product.rating) ? "ri-star-fill text-amber-400" : "ri-star-line text-gray-300"}`}
                      ></i>
                    ))}
                  </div>
                  <span className="text-gray-400 text-xs">({product.reviewCount})</span>
                </div>
                <div className="flex items-center justify-between">
                  <div className="flex items-baseline gap-2">
                    <span className="text-2xl font-bold text-[#1a1a1a]">${product.price}</span>
                    {product.originalPrice && (
                      <span className="text-gray-400 text-sm line-through">${product.originalPrice}</span>
                    )}
                  </div>
                  <button
                    onClick={() => handleAdd(product)}
                    className={`flex items-center justify-center w-10 h-10 rounded-full transition-all duration-300 cursor-pointer ${
                      addedId === product.id
                        ? "bg-[#2D5016] text-white"
                        : "bg-[#F0EDE6] hover:bg-[#2D5016] hover:text-white text-[#2D5016]"
                    }`}
                  >
                    <i className={`text-base ${addedId === product.id ? "ri-check-line" : "ri-shopping-bag-line"}`}></i>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
